import { Injectable } from '@angular/core';

import { ConverterService, PRODUCT_NORMALIZER } from '@spartacus/core';

import { CssHierarchy } from '../models/css-hierarchy.model';

@Injectable({
  providedIn: 'root'
})
export class CssHierarchyMapper {
  constructor(private converter: ConverterService) { }

  convertProducts(cssHierarchy: CssHierarchy): CssHierarchy {
    const hierarchy: CssHierarchy = {};

    if (cssHierarchy.accessoryCategory) {
      hierarchy.accessoryCategory = {
        ...cssHierarchy.accessoryCategory,
        products: this.converter.convertMany(cssHierarchy.accessoryCategory.products, PRODUCT_NORMALIZER)
      };
    }

    if (cssHierarchy.faqCategory) {
      hierarchy.faqCategory = {
        ...cssHierarchy.faqCategory,
        products: this.converter.convertMany(cssHierarchy.faqCategory.products, PRODUCT_NORMALIZER)
      };
    }

    if (cssHierarchy.ifuCategory) {
      hierarchy.ifuCategory = {
        ...cssHierarchy.ifuCategory,
        products: this.converter.convertMany(cssHierarchy.ifuCategory.products, PRODUCT_NORMALIZER)
      };
    }

    if (cssHierarchy.registerProductsCategory) {
      hierarchy.registerProductsCategory = {
        ...cssHierarchy.registerProductsCategory,
        products: this.converter.convertMany(cssHierarchy.registerProductsCategory.products, PRODUCT_NORMALIZER)
      };
    }

    return hierarchy;
  }
}
